import { ConsumerDto } from '../../../shared/type/parentDashboardContext.type';
import { useSafeTranslation } from '../../../hooks/useSafeTranslation';
import { Spinner } from '@chakra-ui/react';
import { ChildOverview } from '../ChildOverview';

export const ChildrenWaitingRoom = ({
  onEditClick,
  pendingChildren
}: {
  onEditClick: (kid: ConsumerDto) => void;
  pendingChildren: ConsumerDto[] | null;
}) => {
  const { t } = useSafeTranslation();

  if (!pendingChildren) {
    return <Spinner />;
  }

  if (!!pendingChildren && pendingChildren.length === 0) {
    return <>{t('parent_assigned_accounts.no_pending_children')}</>;
  }

  return (
    <section>
      {pendingChildren.map((child) => (
        <ChildOverview child={child} consumerId={null} showMoreDetails onEditClick={onEditClick} />
      ))}
    </section>
  );
};
